import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-geia-team',
  templateUrl: './geia-team.component.html',
  styleUrls: ['./geia-team.component.scss']
})
export class GeiaTeamComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
